import { useState } from "react";
import { useDispatch } from "react-redux";
import { fetchRemoveReviews } from "../../../../redux/slices/reviews";
import Alert from "../components/Alert";
import Notification from "../components/Notification";

const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

export default function Review({ data }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const [show, setShow] = useState(false);
  const [textN, setTextN] = useState("Успешно удалено!");
  const [state, setState] = useState("success");

  const handleDelete = () => {
    setOpen(true);
  };

  const deleteReview = () => {
    dispatch(fetchRemoveReviews(data._id));

    setShow(true);
    setTextN("Отзыв успешно удален!");
    setState("success");
    setTimeout(() => {
      setShow(false);
    }, 3500);
  };

  function formatDateToLongDate(isoDateString) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(isoDateString);
    return date.toLocaleDateString("en-US", options);
  }

  return (
    <>
      <Alert
        open={open}
        setOpen={setOpen}
        text={"Удалить отзыв?"}
        subText={
          "Вы уверены что хотите удалить отзыв? Действие нельзя будет отменить."
        }
        btnText={"Удалить"}
        deleteClicked={deleteReview}
      />
      <div className="flex text-sm text-neutral-500 max-w-[900px] px-10 rounded-xl border border-neutral-200 shadow-lg relative">
        <button
          onClick={handleDelete}
          type="button"
          className="absolute top-4 right-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 cursor-pointer text-red-600 hover:text-red-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
            />
          </svg>
        </button>
        <div className="py-5 w-full">
          {/* Аватарка была картинкой со стороннего сервиса (picsum.photos):
              случайное фото постороннего человека рядом с чужим отзывом. */}
          {data.name ? (
            <h3 className="text-lg font-medium text-neutral-900">{data.name}</h3>
          ) : null}
          <p>{formatDateToLongDate(data.date)}</p>

          {/* Оценка есть только у отзывов, написанных через форму на сайте.
              У скриншота её нет — пустые серые звёзды читались бы как «ноль
              из пяти», то есть как плохая оценка. */}
          {data.stars > 0 && (
            <>
              <div className="flex items-center mt-4">
                {[0, 1, 2, 3, 4].map((rating) => (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    key={rating}
                    className={classNames(
                      data.stars > rating ? "text-yellow-400" : "text-neutral-300",
                      "h-5 w-5 flex-shrink-0"
                    )}
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                      clipRule="evenodd"
                    />
                  </svg>
                ))}
              </div>
              <p className="sr-only">{data.stars} из 5 звезд</p>
            </>
          )}

          {data.comment ? (
            <div
              className="mt-4 prose prose-base max-w-none text-neutral-600"
              dangerouslySetInnerHTML={{ __html: data.comment }}
            />
          ) : null}

          {/* Скриншоты показываем крупно: 80×80 не давали прочитать ни строчки,
              а проверить перед публикацией нужно именно текст на картинке. */}
          {data.photos?.length > 0 && (
            <div className="mt-4 flex flex-wrap gap-3">
              {data.photos.map((url, i) => (
                <a
                  key={`${url}-${i}`}
                  href={`${process.env.REACT_APP_BASE_API}${url}`}
                  target="_blank"
                  rel="noreferrer"
                  className="block max-w-[320px] rounded-lg overflow-hidden border border-neutral-200 hover:border-sky-500 transition-colors"
                >
                  <img
                    src={`${process.env.REACT_APP_BASE_API}${url}`}
                    alt="Скриншот отзыва"
                    className="w-full h-auto"
                  />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
      <Notification show={show} setShow={setShow} text={textN} state={state} />
    </>
  );
}
